export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5244.ba115d6f.jpg";